<h2 mat-dialog-title>{{ "remote-guidance.incoming.title" | translate }}</h2>
<div mat-dialog-content>
	<div class="flex min-w-72 flex-row items-center gap-4">
		<mat-icon class="text-primary animate-pulse">smart_display</mat-icon>
		<div class="flex flex-col">
			<span class="text-lg font-bold">
				{{ call.callerLabel ?? ("remote-guidance.glasses" | translate) }}
			</span>
			<span>{{ "remote-guidance.incoming.description" | translate }}</span>
		</div>
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		[mat-dialog-close]="false">
		{{ "remote-guidance.incoming.ignore" | translate }}
	</button>
	<button
		mat-flat-button
		[mat-dialog-close]="true">
		<mat-icon>call</mat-icon>
		{{ "remote-guidance.incoming.answer" | translate }}
	</button>
</div>
